var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-sections"},_vm._l((_vm.sections),function(section,k){return _c(_vm.getComponentType(section),{key:'home_component_' + k,tag:"component",attrs:{"section":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }